export default __webpack_public_path__ + "media/for-online-counselling.df801a5e.png";